import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";

// users
import user1 from "../../../assets/images/users/avatar-1.png";

const ProfileMenu = () => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [username, setusername] = useState("");
  const [isRole, setRole] = useState('')
  const [profileImg, setProfileImg] = useState(null)
  const obj = JSON.parse(localStorage.getItem("authUser"));
  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      setusername(obj.user.firstName);
      setRole(obj.user.role);
      setProfileImg(obj.user.profileImg)
    }
  }, [obj]);


  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item d-flex align-items-center"
          id="page-header-user-dropdown"
          tag="button"
        >{
            profileImg ?
              <img
                className="rounded-circle header-profile-user"
                src={profileImg}
                alt="Header Avatar"
              /> :
              <div
                className={
                  "rounded-circle header-profile-user d-flex align-items-center justify-content-center"
                }
              >
                <span className="font-weight-bold">{username.charAt(0).toUpperCase()}</span>
              </div>
          }
          <p className="d-none d-xl-inline-block ms-2 me-1 mb-0">{username}</p>
          {/* <span className="d-none d-xl-inline-block ms-2 me-1">{isRole}</span> */}
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="/profile">
            <DropdownItem>
              {" "}
              <i className="bx bx-user font-size-16 align-middle me-1" />
              {` Profile`}
            </DropdownItem>
          </Link>
          {/* Do not delete these code's, it will be needed */}
          {/* <Link to="#">
          <DropdownItem>
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem>
         </Link>
         <Link to="#">
          <DropdownItem>
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem>
         </Link> */}
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{` Logout`}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any
};

const mapStatetoProps = state => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
